// @ts-expect-error Could not find a declaration file for module 'feedback-loader/FeedbackLoaderProvider'.
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import OnboardingTour from 'onboarding-tours/components/OnboardingTour';
import { DataFetchingClientProvider } from '../utils/DataFetchingClient';
import { ContainerQueryProvider, ThemeProvider } from '../utils/Styling';
import ErrorBoundary from './error/ErrorBoundary';
import { NativeBackButton } from './NativeBackButton';
import OverviewModalRouter from '../features/overview/components/OverviewModalRouter';
import { AwardModalProvider } from '../features/certificate/components/AwardModalProvider';
/* @bend-expect quartz-no-already-provided-providers */
import { BrowserRouter, useHistory } from 'quartz-routing/react-router';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useHasHistory = () => {
  try {
    useHistory();
    return true;
  } catch (_unused) {
    return false;
  }
};
const BrowserRouterRenderer = ({
  children
}) => {
  const hasHistory = useHasHistory();
  if (!hasHistory) {
    var _PortalIdParser$get;
    return /*#__PURE__*/_jsx(BrowserRouter, {
      basename: `/academy/${(_PortalIdParser$get = PortalIdParser.get()) !== null && _PortalIdParser$get !== void 0 ? _PortalIdParser$get : 0}`,
      children: children
    });
  }
  return children;
};
export const ACAppShell = ({
  dataFetchingClient,
  children
}) => {
  return /*#__PURE__*/_jsx(ContainerQueryProvider, {
    children: /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
      children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: dataFetchingClient,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsxs(CopilotProvider, {
            children: [/*#__PURE__*/_jsx(OnboardingTour, {}), /*#__PURE__*/_jsx(BrowserRouterRenderer, {
              children: /*#__PURE__*/_jsx(ErrorBoundary, {
                children: /*#__PURE__*/_jsxs(AwardModalProvider, {
                  children: [/*#__PURE__*/_jsx(NativeBackButton, {}), children, /*#__PURE__*/_jsx(OverviewModalRouter, {})]
                })
              })
            })]
          })
        })
      })
    })
  });
};